import React, { useEffect, useState } from 'react';
import GlobalMeta from '../../reusable/GlobalMeta';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import ImageBGSection from '../../reusable/fieldGroups/ImageBGSection';
import InternalBanner from '../../reusable/fieldGroups/InternalBanner';
import Accreditations from '../../reusable/fieldGroups/Accreditations';
import { Box } from '@mui/system';
import PartnersCarousel from '../../reusable/PartnersCarousel';
import RandomTestimonial from '../../reusable/RandomTestimonial';
import LatestInsights from '../../reusable/LatestInsights';
import ConsultingMenu from './ConsultingMenu';
import PageContent from '../../layout/PageContent';
import ConsultingAreas from '../../reusable/fieldGroups/ConsultingAreas';

export default function Consulting({ page }) {

    const [pageData, setPageData] = useState();

    //Fetch page
    const { isPending, isError, data, error } = useQuery(
        ['consulting'], //Query key
        () => axios({ //Query function
            method: 'get',
            url: WP_API_Settings.endpoint + 'wp/v2/pages?slug=consulting&_embed=true&acf_format=standard'
        })
    );

    useEffect(() => {
        if (data?.data) {
            setPageData(data.data[0]);
        }
    }, [data]);

    // console.log('pageData:', pageData);

    return (
        <>
            <GlobalMeta />
            <InternalBanner
                featuredImage={pageData?._embedded?.['wp:featuredmedia']?.[0]?.source_url}
                banner={pageData?.acf.internal_banner}
            />
            <ConsultingMenu />
            <PageContent
                content={pageData?.content.rendered}
            />
            <ConsultingAreas
                areas={pageData?.acf.consulting_areas}
                loading={!pageData}
            />
            <Box
                sx={{
                    width: '100%',
                    height: '4rem',
                }}
            />
            <RandomTestimonial
                testimonials={pageData?.acf.testimonials}
                loading={!pageData}
            />
            <PartnersCarousel
                loading={!pageData}
                page={'consultancy'}
            />
            <ImageBGSection
                content={pageData?.acf.image_background}
                loading={!pageData}
            />
            <Box
                sx={{
                    width: '100%',
                    height: '4rem',
                }}
            />
            <Accreditations
                accreditations={pageData?.acf.accreditations}
                loading={!pageData}
                page={'home'}
            />
            <LatestInsights
                loading={!pageData}
                page={'consulting'}
            />
        </>
    );
};